import cx from 'classnames'
import type React from 'react'

import css from './Selector.module.scss'

type Classnames = {
  container?: string
  icon?: string
  title?: string
}

type Props = {
  title: string
  icon: React.ReactNode
  active?: boolean
  disabled?: boolean
  background?: boolean
  classnames?: Classnames
  onClick: () => void
}

const Selector = ({
  title,
  icon,
  active,
  disabled,
  background,
  classnames,
  onClick,
}: Props) => {
  const cn: Classnames = {
    container: cx(
      css.container,
      {
        [css.active]: active,
        [css.disabled]: disabled,
        [css.background]: background,
      },
      classnames?.container
    ),
    title: cx(css.title, classnames?.title),
    icon: cx(css.icon, classnames?.icon),
  }

  return (
    <div className={cn.container} onClick={() => !disabled && onClick()}>
      <div className={cn.title}>{title}</div>
      <div className={cn.icon}>{icon}</div>
    </div>
  )
}

export default Selector
